import React from 'react'
import { countryCodeToFlagEmoji, countryDisplayName } from '../../utils/format'

interface CountryFlagIconProps {
  code: string
  className?: string
  testId?: string
}

/**
 * Compact country indicator — emoji flag with native hover tooltip.
 * Used in graph node panel and compact profile rows.
 */
const CountryFlagIcon: React.FC<CountryFlagIconProps> = ({
  code,
  className = '',
  testId = 'country-flag-icon',
}) => {
  const name = countryDisplayName(code)
  const emoji = countryCodeToFlagEmoji(code)
  if (!emoji) return null
  return (
    <span
      className={`inline-block leading-none shrink-0 cursor-default select-none text-sm ${className}`}
      title={name}
      aria-label={name}
      data-testid={testId}
    >
      {emoji}
    </span>
  )
}

export default CountryFlagIcon
